import {Button, Icon} from "~/components";
import {Tooltip} from "antd";
import {useState} from "react";

function HostInfoAction({item, setItemEdit, openModal, can, handleStatus})
{
	const [loadingStatus, setLoadingStatus] = useState(false);

	const [loadingStatusCancel, setLoadingStatusCancel] = useState(false);

	const buttonHandlers = {
		status: async (item, status) => {
			if(status === 'cancel') {
				setLoadingStatusCancel(true);
			}
			else {
				setLoadingStatus(true);
			}
			await handleStatus(item, status);
			if(status === 'cancel') {
				setLoadingStatusCancel(false);
			}
			else {
				setLoadingStatus(false);
			}
		},
		edit: () => {
			setItemEdit(item);
			openModal('edit');
		},
		delete: () => {
			setItemEdit(item);
			openModal('delete');
		},
	};

	const actionButtons = [
		can.edit && <Button key="edit" background blue leftIcon={Icon.edit} onClick={buttonHandlers.edit}></Button>,
		can.delete && <Button key="delete" background red leftIcon={Icon.delete} onClick={buttonHandlers.delete}></Button>,
	];

	return (
		<div className="table-action d-flex">
			{
				can.status && <>
					{
						item.status.key !== 'confirm' && <Tooltip title="Duyệt">
							<Button loading={loadingStatus} background blue noneBorder small leftIcon={Icon.success} onClick={() => buttonHandlers.status(item, 'confirm')} />
						</Tooltip>
					}
					{
						item.status.key !== 'cancel' && <Tooltip title="Hủy">
							<Button loading={loadingStatusCancel} background red noneBorder small leftIcon={Icon.close} onClick={() => buttonHandlers.status(item, 'cancel')} />
						</Tooltip>
					}
				</>
			}
			{actionButtons}
		</div>
	)
}

export default HostInfoAction;